<template>
  <div class="screent_button">
    <button>{{ title }}</button>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
  },
};
</script>

<style lang="scss">
.screent_button {
  --color: #4aa4e2;
  position: relative;
  z-index: 1;
}
/* 
.screent_button::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background: transparent;
  top: 0;
  left: 0;
  z-index: -5;
  border-top: 3px solid var(--color);
  border-left: 3px solid var(--color);
  transition: 0.5s;
}

.screent_button::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  background: transparent;
  bottom: 0;
  right: 0;
  z-index: -5;
  border-right: 3px solid var(--color);
  border-bottom: 3px solid var(--color);
  transition: 0.5s;
}

.screent_button:hover::before {
  width: 100%;
  height: 100%;
}

.screent_button:hover::after {
  width: 100%;
  height: 100%;
} */

.screent_button button {
  padding: 0.4em 1.3em;
  font-size: 20px;
  color: #68d8fe;
  border: none;
  cursor: pointer;
  font-family: inherit;
  background: none;
  border: 2px solid var(--color);
  transition: all .25s;

  &:hover {
    background-color: #1C47B2;
  }
}
</style>
